export enum Locales {
	ENGLISH = "en",
	HUNGARIAN = "hu",
}
